import { Trophy } from 'lucide-react';
import type { PromotionMetricsBuyer } from '@/client/types/promotion';
import { money, numberFmt, type ColorScale } from './analytics';

export const TopSpendersTable: React.FC<{ rows: PromotionMetricsBuyer[]; categoryColor: ColorScale }> = ({ rows, categoryColor }) => (
  <div className="rounded-2xl border border-gray-100 bg-white shadow-sm">
    <div className="flex items-center gap-2 border-b border-gray-100 px-5 py-3">
      <Trophy className="h-4 w-4 text-emerald-600" />
      <h3 className="text-sm font-semibold text-gray-900">Top spenders</h3>
    </div>
    {rows.length === 0 ? (
      <p className="py-8 text-center text-sm text-gray-400">No purchases in this period.</p>
    ) : (
      <div className="divide-y divide-gray-100">
        {rows.map((r, i) => (
          // Buyers are grouped by org/user id server-side, so names can repeat.
          <div key={`${r.uid ?? 'anon'}-${r.buyer}-${i}`} className="flex items-center gap-3 px-5 py-3">
            <span className="w-5 shrink-0 text-center text-xs font-semibold text-gray-400">{i + 1}</span>
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-medium text-gray-900">{r.buyer}</p>
              <p className="flex items-center gap-1.5 text-[11px] text-gray-400">
                <span
                  className="h-1.5 w-1.5 shrink-0 rounded-full"
                  style={{ backgroundColor: categoryColor(r.top_category) }}
                />
                <span className="truncate">
                  mostly {r.top_category} · {numberFmt.format(r.orders)} promos
                </span>
              </p>
            </div>
            <span className="shrink-0 text-sm font-semibold tabular-nums text-gray-900">{money(r.revenue)}</span>
          </div>
        ))}
      </div>
    )}
  </div>
);
